import { StyleHelpers } from './style-helpers.js';
import { StyleLineHeight } from './style-line-height.js';
import { StyleBlockFormatter } from './style-block-formatter.js';
import { StyleFormatPainter } from './style-format-painter.js';
import { StyleCleaner } from './style-cleaner.js';
import { StyleSimplifier } from './style-simplifier.js';
import { StyleNormalizer } from './style-normalizer.js';
import { StyleJustifier } from './style-justifier.js';


export function Style (pEditor)
{
  this.helpers = new StyleHelpers(pEditor, this);
  this.lineHeight = new StyleLineHeight(pEditor, this);
  this.blockFormatter = new StyleBlockFormatter(pEditor, this);
  this.formatPainter = new StyleFormatPainter(pEditor, this);
  this.cleaner = new StyleCleaner(pEditor, this);
  this.simplifier = new StyleSimplifier(pEditor, this);
  this.normalizer = new StyleNormalizer(pEditor, this);
  this.justifier = new StyleJustifier(pEditor, this);

  
  this.reInit = () =>
  {
    this.blockFormatter.reInit();
  }
}